import { contentApi } from './api';

export interface SiteContent {
  id: number;
  page_type: string;
  content: any;
  is_published: boolean;
  published_at: string | null;
  version: number;
}

export interface SiteConfig {
  id: number;
  config_key: string;
  config_value: any;
  description: string | null;
}

export interface PublishHistory {
  id: number;
  version: number;
  content_summary: any;
  published_by: string | null;
  status: string;
  created_at: string;
}

export const contentService = {
  async getPublishedContent(pageType: string): Promise<SiteContent | null> {
    try {
      const response = await contentApi.getPublished(pageType);
      if (response.success) {
        return response.data || null;
      }
      return null;
    } catch (error) {
      console.error('Error fetching content:', error);
      return null;
    }
  },

  async getAllContents(): Promise<SiteContent[]> {
    try {
      const response = await contentApi.getAll();
      if (response.success && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching contents:', error);
      return [];
    }
  },

  async saveContent(pageType: string, content: any): Promise<boolean> {
    try {
      const response = await contentApi.save(pageType, content);
      if (response.success) {
        return true;
      }
      if (response.code === 'PERMISSION_DENIED') {
        alert('您没有权限执行此操作');
      }
      return false;
    } catch (error) {
      console.error('Error saving content:', error);
      return false;
    }
  },

  async publishContent(pageType: string): Promise<boolean> {
    try {
      const response = await contentApi.publish(pageType);
      if (response.success) {
        return true;
      }
      if (response.code === 'PERMISSION_DENIED') {
        alert('您没有权限执行此操作');
      }
      return false;
    } catch (error) {
      console.error('Error publishing:', error);
      return false;
    }
  },

  async getConfig(key: string): Promise<any | null> {
    try {
      const response = await contentApi.getConfig(key);
      if (response.success) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching config:', error);
      return null;
    }
  },

  async updateConfig(key: string, value: any): Promise<boolean> {
    try {
      const response = await contentApi.updateConfig(key, value);
      if (response.success) {
        return true;
      }
      if (response.code === 'PERMISSION_DENIED') {
        alert('您没有权限执行此操作');
      }
      return false;
    } catch (error) {
      console.error('Error updating config:', error);
      return false;
    }
  },

  async getPublishHistory(): Promise<PublishHistory[]> {
    try {
      const response = await contentApi.getHistory();
      if (response.success && response.data) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('Error fetching history:', error);
      return [];
    }
  }
};
